/**
 * Shared chart color palette for consistent styling across all chart components.
 * Professional color palette optimized for data visualization.
 */
export const CHART_COLORS = [
  "hsl(158, 75%, 55%)",   // Mint (primary)
  "hsl(210, 70%, 60%)",   // Blue
  "hsl(280, 60%, 60%)",   // Purple  
  "hsl(340, 70%, 55%)",   // Rose
  "hsl(30, 85%, 55%)",    // Orange
  "hsl(190, 80%, 45%)",   // Cyan
  "hsl(50, 90%, 50%)",    // Yellow
  "hsl(0, 70%, 55%)",     // Red
  "hsl(120, 50%, 50%)",   // Green
  "hsl(260, 70%, 65%)",   // Violet
  "hsl(15, 80%, 60%)",    // Coral
  "hsl(180, 60%, 50%)",   // Teal
  "hsl(300, 50%, 55%)",   // Magenta
  "hsl(45, 85%, 55%)",    // Gold
] as const;

/**
 * Get a color from the palette by index (cycles through if index > length)
 */
export function getChartColor(index: number): string {
  return CHART_COLORS[index % CHART_COLORS.length];
}
